"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var T = _interopRequireWildcard(require("prop-types"));
var _copyTextToClipboard = _interopRequireDefault(require("../../utils/copyTextToClipboard"));
var _AuButton = _interopRequireWildcard(require("./AuButton"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "responsive_table-module__container___SN_XF",
  "table": "responsive_table-module__table___atfaD",
  "table_body": "responsive_table-module__table_body___epJTn",
  "header_row": "responsive_table-module__header_row___WJh9S",
  "column": "responsive_table-module__column___SsD03",
  "title": "responsive_table-module__title___CmJN4",
  "toggle": "responsive_table-module__toggle___jJbuI",
  "expand": "responsive_table-module__expand___F1a4u responsive_table-module__toggle___jJbuI",
  "collapse": "responsive_table-module__collapse___QA5YP responsive_table-module__toggle___jJbuI",
  "sortable_column": "responsive_table-module__sortable_column___dKHmz responsive_table-module__column___SsD03",
  "units": "responsive_table-module__units____IfvR",
  "row": "responsive_table-module__row___LPvGL",
  "expanded": "responsive_table-module__expanded___bFWek responsive_table-module__row___LPvGL",
  "content": "responsive_table-module__content___SdAZQ",
  "even": "responsive_table-module__even___cO05B responsive_table-module__row___LPvGL",
  "odd": "responsive_table-module__odd___SMifW responsive_table-module__row___LPvGL",
  "toggle_column": "responsive_table-module__toggle_column___dpfUC responsive_table-module__column___SsD03",
  "left": "responsive_table-module__left___Pc1Dk",
  "right": "responsive_table-module__right___j3EPk",
  "center": "responsive_table-module__center___yZ32J",
  "hidden": "responsive_table-module__hidden___sXudr",
  "switch_column": "responsive_table-module__switch_column___HtWac responsive_table-module__column___SsD03",
  "actions_column": "responsive_table-module__actions_column___sueyQ responsive_table-module__column___SsD03",
  "expansion": "responsive_table-module__expansion___KF9gd",
  "collapsed_columns": "responsive_table-module__collapsed_columns___L7q8h",
  "column_cell": "responsive_table-module__column_cell___uBfQk",
  "label": "responsive_table-module__label___wIbL7",
  "colon": "responsive_table-module__colon___Rre1_",
  "msg": "responsive_table-module__msg___BrIG2",
  "msgicon": "responsive_table-module__msgicon___R9APo",
  "no_rows": "responsive_table-module__no_rows___iaYdK responsive_table-module__msg___BrIG2",
  "fetching": "responsive_table-module__fetching___b5n61 responsive_table-module__msg___BrIG2",
  "ellipsis": "responsive_table-module__ellipsis___NKeuz",
  "highlight": "responsive_table-module__highlight___ilhHD",
  "tooltip": "responsive_table-module__tooltip___jhh1B",
  "copy": "responsive_table-module__copy___DshAD"
};
class Tooltip extends _react.default.Component {
  static propTypes = {
    containerRef: T.shape({
      current: T.object
    }).isRequired,
    data: T.string.isRequired,
    style: T.object
  };
  state = {
    copied: false
  };
  UNSAFE_componentWillMount() {
    clearTimeout(this._timeout);
  }
  handleOnCopy = (0, _bind.default)(_context = this.handleOnCopy).call(_context, this);
  handleOnCopy() {
    (0, _copyTextToClipboard.default)(this.props.data);
    this.setState({
      copied: true
    }, () => this._timeout = (0, _setTimeout2.default)(() => this.setState({
      copied: false
    }), 2000));
  }
  renderTooltip() {
    const {
      style
    } = this.props;
    const {
      copied
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip,
      style: style
    }, this.props.children, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      size: _AuButton.BUTTON_SIZE_MEDIUM,
      type: _AuButton.BUTTON_TYPE_PLAIN,
      disabled: copied,
      className: styles.copy,
      displayId: copied ? 'au.copied' : 'au.copy',
      onClick: this.handleOnCopy
    }));
  }
  render() {
    return /*#__PURE__*/_reactDom.default.createPortal(this.renderTooltip(), this.props.containerRef);
  }
}
exports.default = Tooltip;